import { render } from "./OriginManage.vue?vue&type=template&id=2abc7fdc&scoped=true"
import script from "./OriginManage.vue?vue&type=script&lang=js"
export * from "./OriginManage.vue?vue&type=script&lang=js"

import "./OriginManage.vue?vue&type=style&index=0&id=2abc7fdc&scoped=true&lang=css"
import "./OriginManage.vue?vue&type=style&index=1&id=2abc7fdc&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2abc7fdc"]])

export default __exports__